import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, useOverlay, Paragraph } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../../hooks/useNotifications'
import { invalidateOrdinanceCache } from '../../../../services/personService'
import { PersonContext } from '../../PersonContext'

export default function InvalidateOrdinanceCacheButton({ refetchOrdinances }) {
  const { t } = useTranslation()
  const invalidateOrdinanceCacheDialogOpener = useOverlay()
  const { currentPerson } = useContext(PersonContext)
  const { error } = useNotifications()

  const confirmBtnOnClick = async () => {
    try {
      invalidateOrdinanceCacheDialogOpener.close()
      await invalidateOrdinanceCache(currentPerson.id)
      refetchOrdinances()
    } catch (err) {
      error(
        t('person.ordinances.errors.invalidatingOrdinanceCache', {
          defaultValue: `Error invalidating ordinance cache: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  return (
    <>
      <Button emphasis="medium" onClick={invalidateOrdinanceCacheDialogOpener.open}>
        {t('ordinances.invalidateOrdinanceCache.invalidateOrdinanceCache', 'Invalidate Ordinance Cache')}
      </Button>
      <DialogOverlay
        {...invalidateOrdinanceCacheDialogOpener}
        title={t('ordinances.invalidateOrdinanceCache.invalidateOrdinanceCache', 'Invalidate Ordinance Cache')}
        subtitle={currentPerson.id}
      >
        <Paragraph size="sm">
          {t(
            'ordinances.invalidateOrdinanceCache.body',
            "Are you sure you want to invalidate this person's ordinance cache?"
          )}
        </Paragraph>
        <DialogOverlayFooter>
          <DialogOverlayActions>
            <Button emphasis="high" onClick={confirmBtnOnClick}>
              {t('action.confirm', 'Confirm')}
            </Button>
            <Button emphasis="medium" onClick={invalidateOrdinanceCacheDialogOpener.close}>
              {t('action.cancel', 'Cancel')}
            </Button>
          </DialogOverlayActions>
        </DialogOverlayFooter>
      </DialogOverlay>
    </>
  )
}
